import React from 'react';
import {motion} from 'framer-motion';
import {useInView} from 'framer-motion';
import {useRef} from 'react';

const Mission = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, {once: true, margin: "-100px"});

  return (
    <section id="mission" className="py-20 bg-gray-50 w-full" ref={ref}>
      <div className="container mx-auto px-6">
        <motion.div 
          initial={{opacity: 0, y: 50}} 
          animate={isInView ? {opacity: 1, y: 0} : {opacity: 0, y: 50}} 
          transition={{duration: 0.8}}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-8">
            Mission
          </h2>
          <div className="w-24 h-1 bg-azure-600 mx-auto mb-12"></div>
          <p className="text-xl text-gray-700 leading-relaxed">
            Unsere Mission: Wir schaffen Klarheit im KI-Dschungel und geben KMU Orientierung bei der digitalen Transformation. Mit innovativen Lösungen, persönlicher Beratung und praxistauglichen KI-Anwendungen – von der Strategie bis zur Implementierung.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Mission;